import { useSelector } from 'react-redux';
import { ReducerKeys } from '..';
import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { StateStatus } from '../../utils/common';

/* selector: useGetSchemeTypes */

interface ISChemeTypesData {
  applicant_type_id: number;
  code: 'EU' | 'NON_EU' | 'IOSS';
  description: string;
}

interface ISChemeTypesOutput {
  status: StateStatus;
  data: ISChemeTypesData[] | null;
}

export const useGetSchemeTypes = (): ISChemeTypesOutput => {
  const { status, data } = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.REGISTER_REDUCER].OSSSchemesList
  );
  return { status, data };
};

/* selector: useGetCountries */

interface ICountriessData {
  country_id: string;
  code: string;
  description: string;
  numeric_code: number;
}

interface ICountriesOutput {
  status: StateStatus;
  data: ICountriessData[] | null;
}

export const useGetCountries = (): ICountriesOutput => {
  const { status, data } = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.REGISTER_REDUCER].countriesList
  );
  return { status, data };
};

export const useGetNonInStateIncludeMSID = (): ICountriesOutput => {
  const { status, data } = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.REGISTER_REDUCER].importCountries
  );
  return { status, data };
};

/* selector: useGetRegisterStatus */

export const useGetRegisterStatus = (): StateStatus => {
  const status = useSelector(
    (state: any) => state[ReducerKeys.REGISTER_REDUCER].registerUserStatus
  );
  return status;
};
